export default "__VITE_ASSET__Daf14M3d__"